// src/TelaInicial.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaShoppingCart, FaIdCard, FaCalculator, FaHome, FaListAlt, FaHeadset } from 'react-icons/fa';
import ButtonSquad from '../components/ButtonSquad';

const InterfaceAssociados = () => {
  const navigate = useNavigate();
  const [colunas, setColunas] = useState(getGridColumns());
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      setColunas(getGridColumns());
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${colunas}, 1fr)`,
    gap: isMobile ? '20px' : '30px',
    width: '100%',
    maxWidth: '900px',
    margin: isMobile ? '0 auto' : '-20px',
    padding: isMobile ? '0 20px' : '0 40px',
    justifyContent: isMobile ? 'center' : 'start',
  };

  const botoes = [
    { 
      texto: 'Enviar Pedido', 
      rota: '/enviarpedido', 
      icon: FaShoppingCart,
      gradient: 'linear-gradient(135deg, #ff5650ff 0%, #FFA07A 100%)' // Azul ardósia médio
    },
    { 
      texto: 'Adicionar Saldo', 
      rota: '/staff/adicionar-saldo', 
      icon: FaIdCard,
      gradient: 'linear-gradient(135deg, #20b258ff 0%, #48D1CC 100%)' // Verde mar médio
    },
    { 
      texto: 'Caixa', 
      rota: '/staff/caixa', 
      icon: FaCalculator,
      gradient: 'linear-gradient(135deg, #5a8ecdff 0%, #8470FF 100%)' // Coral médio
    },
    { 
      texto: 'Acompanhar Pedidos', 
      rota: '/staff/acompanhar-pedido-staff', 
      icon: FaListAlt,
      gradient: 'linear-gradient(135deg, #ddc74cff 0%, #FFEC8B 100%)' // Amarelo dourado
    },
    { 
      texto: 'Atendimentos', 
      rota: '/staff/atendimentos', 
      icon: FaHeadset,
      gradient: 'linear-gradient(135deg, #FF8C00 0%, #FFA500 100%)'
    }
  ];

  return (
    <Layout title="Bem-vindo(a)" icon={FaHome}>
      {/* Cabeçalho com Logo e Título */}
      <div style={styles.header}>
        <div style={styles.logoContainer}>
          <img 
            src="/azulaocozinheiro.png" // Altere para o caminho correto da imagem
            alt="Azulão" 
            style={styles.logo}
          />
        </div>
        <div style={styles.titleContainer}>
          <h1 style={styles.title}>Lanchonete</h1>
          <p style={styles.subtitle}>Sistema de Gestão</p>
        </div>
      </div>

      {/* Grade de Botões */}
      <div style={styles.gridContainer}>
        <div style={gridStyle}>
          {botoes.map((botao, index) => (
            <ButtonSquad
              key={index}
              texto={botao.texto}
              icon={botao.icon}
              isMobile={isMobile}
              onClick={() => navigate(botao.rota)}
              gradient={botao.gradient}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

const getGridColumns = () => {
  const largura = window.innerWidth;
  if (largura < 600) return 2;
  if (largura < 900) return 2;
  return 3;
};

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '30px',
    padding: '20px',
    textAlign: 'center',
    marginBottom: '30px', 
    gap: '10px'
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: '53px',
    height: '101px',
    objectFit: 'cover',

  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#1A3B7D',
    margin: '0',
    fontFamily: 'Montserrat, sans-serif',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  subtitle: {
    fontSize: '1rem',
    color: '#666',
    margin: '5px 0 0 0',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '300'
  },
  gridContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px'
  }
};

export default InterfaceAssociados;